import { render, staticRenderFns } from "./net.vue?vue&type=template&id=24f5d0a6&scoped=true"
import script from "./net.vue?vue&type=script&lang=js"
export * from "./net.vue?vue&type=script&lang=js"
import style0 from "./net.vue?vue&type=style&index=0&id=24f5d0a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5d0a6",
  null
  
)

export default component.exports